import {FontSizeOutlined, TeamOutlined} from "@ant-design/icons";
import {ReactNode} from "react";
import {PUBLIC_PROFILE_BLOCK_LIBRARY, PublicProfileBlockLibraryItem} from "../domain";
import {
  BlockLibraryButton,
  BlockLibraryGrid,
  BlockLibraryGroup,
  BlockLibraryGroupTitle,
  BlockLibraryModal,
} from "./public-profile-page.style";

const BLOCK_ICONS: Record<string, string> = {
  "one-to-one-session": "/icons/phone-fill.png",
  "live-events": "/icons/mic-fill.png",
  store: "/icons/shopping-cart-2-fill.png",
  text: "/icons/t-box-fill.png",
};

const GROUP_ICONS: Record<string, ReactNode> = {
  Coachli: <TeamOutlined />,
  Content: <FontSizeOutlined />,
};

export function AddPublicProfileBlockModal({
  visible,
  onClose,
  onSelect,
}: {
  visible: boolean;
  onClose: () => void;
  onSelect: (block: PublicProfileBlockLibraryItem) => void;
}) {
  return (
    <BlockLibraryModal
      title="Add a block"
      open={visible}
      footer={null}
      centered
      width={680}
      destroyOnClose
      onCancel={onClose}
    >
      {(["Coachli", "Content"] as const).map((group) => (
        <BlockLibraryGroup key={group}>
          <BlockLibraryGroupTitle>
            <span className="group-icon" aria-hidden="true">
              {GROUP_ICONS[group]}
            </span>
            {group}
          </BlockLibraryGroupTitle>
          <BlockLibraryGrid>
            {PUBLIC_PROFILE_BLOCK_LIBRARY.filter((block) => block.group === group).map(
              (block) => (
                <BlockLibraryButton
                  type="button"
                  key={block.id}
                  onClick={() => onSelect(block)}
                >
                  <span className="icon">
                    <img src={BLOCK_ICONS[block.id]} alt="" aria-hidden="true" />
                  </span>
                  <span>
                    <strong>{block.name}</strong>
                    <small>{block.description}</small>
                  </span>
                </BlockLibraryButton>
              )
            )}
          </BlockLibraryGrid>
        </BlockLibraryGroup>
      ))}
    </BlockLibraryModal>
  );
}
